export enum SessionTaskStatus {
  COMPLETED = 'completed',
  PENDING = 'pending',
  URGENT = 'urgent'
}

export enum SessionTaskType {
  ACCOUNT_INFO = 'account-info',
  DOCUMENTS = 'documents',
  ASSESSMENTS = 'assessments',
}
